















import { Vue, Prop, Component, Watch } from 'vue-property-decorator'
import _ from 'lodash'
import {
  State,
  Getter,
  Action,
  Mutation,
  namespace,
} from 'vuex-class'

@Component
export default class App extends Vue {

  @Getter('components/level')
  private levelGetter!: {
    id?: string,
    mode: string,
  }

  get MainComponent() {
    const page = this.$route.params.page
    return () => page ? import(`@/views/${page}/Index.vue`) : import(`@/views/Index.vue`)
  }
  get ChildComponent() {
    const component = this.$route.params.id
      ? this.$route.params.page === 'campaign'
        ? 'Detail'
        : _.chain(this.$route.params.tab).camelCase().upperFirst().value()
      : _.chain(this.$route.params.component).camelCase().upperFirst().value()
    const page = this.$route.params.page
    // console.log('param', this.$route.params, 'component', component)
    return () => import(`@/views/${page}/${component}.vue`)
  }
}

